<template>
  <div id="terms-text-container">
    <div class="terms-text-outer">
      <div class="terms-text-inner" v-html="htmltext"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TermsText',
  props: ['htmltext'],
  data: () => ({})
}
</script>
<style lang="less">
#terms-text-container,
#terms-text-container p,
div.terms-text-inner p {
  color: #222;
  line-height: 140%;
  text-align: left;
}
</style>
